import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../../theme';

const { colors, fonts, fontSize, spacing, radius } = redesignTheme;

export const useBlockEditorStyles = makeStyles(() => ({
  editArea: {
    width: '100%',
    border: 0,
    outline: 'none',
    resize: 'none',
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.primaryDark,
    background: 'transparent',
  },
  titleInput: {
    width: '100%',
    border: 0,
    outline: 'none',
    fontFamily: fonts.opensans,
    color: colors.primaryDark,
    background: 'transparent',
  },
  imageBlock: {
    position: 'relative',
    padding: 5,
    minHeight: 200,
  },
  imagePreview: {
    width: '100%',
    display: 'block',
  },
  imageActions: {
    position: 'absolute',
    top: 12,
    right: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
  },
  imageActionBtn: {
    width: 36,
    height: 36,
    padding: 8,
    borderRadius: radius.sm,
  },
  sommaire: {
    padding: spacing.sm,
  },
  sommaireTitle: {
    fontFamily: fonts.opensansBold,
    fontSize: 18,
    color: colors.primaryDark,
    marginBottom: spacing.sm,
  },
  sommaireChapter: {
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.base,
    color: colors.primaryDark,
    marginTop: spacing.xs,
  },
  sommaireSubtitle: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.primaryDark,
    marginTop: 4,
    paddingLeft: spacing.sm,
  },
  freeQuestionLines: {
    marginTop: spacing.sm,
  },
  lineControl: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xs,
    marginTop: spacing.sm,
    fontFamily: fonts.opensans,
    fontSize: fontSize.sm,
    color: colors.text,
  },
  numLinesInput: {
    width: 56,
    height: 32,
    padding: '0 8px',
    border: `1px solid ${colors.border}`,
    borderRadius: 4,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
  },
  linesContainer: {
    marginTop: spacing.sm,
  },
  line: {
    height: 24,
    borderBottom: `1px solid ${colors.border}`,
    marginBottom: 4,
  },
  lastLine: {
    marginBottom: 0,
  },
  encyclopediaWrap: {
    display: 'flex',
    gap: spacing.sm,
    alignItems: 'flex-start',
  },
  encyclopediaIcon: {
    width: 24,
    height: 24,
    flexShrink: 0,
    fill: colors.primary,
  },
  icon: {
    width: 20,
    height: 20,
    fill: colors.white,
  },
}));
